<template>
  <div ref="defineTab">
    <panel-block v-if="selectedObjectModelRelation.can(ObjectModelRelationCapability.labelable)" id="pn-name">
      <panel-item>
        <label :for="selectedObjectModelRelation.idForProp('label')">{{ label }}</label>
        <expandable-textarea
          :id="selectedObjectModelRelation.idForProp('label')"
          v-model="selectedObjectModelRelation.label_title"
          :placeholder="placeholder"></expandable-textarea>
      </panel-item>
    </panel-block>
    <panel-block v-if="selectedObjectModelRelation.can(ObjectModelRelationCapability.portalClaimable)" id="pn-portal">
      <panel-item>
        <row>
          <column>
            <label for="portal-for-claiming">Portal for claiming</label>
          </column>
          <suffix>
            <help-tooltip :text="tooltipText"></help-tooltip>
          </suffix>
        </row>
        <a-select
          v-model="selectedObjectModelRelation.portal_for_claiming"
          :options="portalOptions"
          id="portal-for-claiming"
        ></a-select>
      </panel-item>
    </panel-block>
  </div>
</template>


<script lang="ts">
  import Vue from "vue";
  import {ObjectModelRelationCapability} from "../../../common/models/objectModelRelations/objectModelRelationCapability";
  import selectedMixin from "../mixins/selectedMixin";
  import {ObjectModelRelationType} from "~/enums/objectModelRelationType";
  import {IVOptionSetLocal} from "~/interfaces/vSelectInterfaces";

  export default Vue.extend({
    mixins: [selectedMixin],
    data: function () {
      return {
        ObjectModelRelationCapability,
      };
    },
    computed: {
      isAccountRelationship(): boolean {
        return this.selectedObjectModelRelation.isAccountRelationship;
      },
      isUserAccountRelationship(): boolean {
        return this.objectModelRelation.relation_type === ObjectModelRelationType.Account;
      },
      isEntityAccountRelationship(): boolean {
        return this.objectModelRelation.relation_type === ObjectModelRelationType.EntityAccount;
      },
      label(): string {
        if (this.isAccountRelationship) {
          return "Relationship Name";
        } else {
          return "Role of this Object Model";
        }
      },
      placeholder(): string {
        if (this.selectedObjectModelRelation.relation_type === ObjectModelRelationType.Account) {
          return "Enter account name...";
        } else if (this.selectedObjectModelRelation.relation_type === ObjectModelRelationType.EntityAccount) {
         return "Enter entity account name...";
        } else {
          return "Enter relationship name...";
        }
      },
      tooltipText(): string {
        return "A branded email will be sent out to any account associated, directing the user to create an entity account and claim the record."
      },
      portalOptions(): IVOptionSetLocal {
        return {
          labelKey: 'label',
          valueKey: 'type',
          options: [
            { label: 'OneStop', type: 'onestop' },
            { label: 'DNR', type: 'dnr' },
          ],
        };
      },
    },
  });
</script>